import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {fuseAnimations} from "@fuse/animations";
import {MatIcon} from "@angular/material/icon";
import {MatRipple} from "@angular/material/core";
import {MatTooltip} from "@angular/material/tooltip";
import {NgIf} from "@angular/common";
import {TranslocoDirective, TranslocoPipe} from "@ngneat/transloco";
import {RouterLink} from "@angular/router";
import {MatButton} from "@angular/material/button";

@Component({
    selector       : 'contact-component',
    templateUrl    : './contact-page.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    animations   : fuseAnimations,
    standalone     : true,
    imports: [
        MatIcon,
        MatRipple,
        MatTooltip,
        NgIf,
        TranslocoDirective,
        TranslocoPipe,
        RouterLink,
        MatButton
    ],
})
export class ContactPageComponent implements OnInit, OnDestroy
{

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


}
